import ministryService from "../../../../services";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
export default {
  namespaced: true,
  state: {
    loading: false,
     dataObj: {},
  },
  getters: {
    loading(state) {
      return state.loading;
    },
    dataObj(state) {
      return state.dataObj;
    },
  },
  mutations: {
    setLoading(state, payload) {
      state.loading = payload;
    },
    setData(state, payload) {
      state.dataObj = payload;
    },
  },
  actions: {
    async fetchRecordData({ commit }, params) {
      commit("setLoading", true);
      try {
        const data = await ministryService.fetchRequest(params);
        commit("setData", data.data);
      } catch (err) {
      } finally {
        commit("setLoading", false);
      }
    },
    async freezeRequest({ commit, dispatch }, id) {
      commit("setLoading", true);
      try {
        const res = await ministryService.freezeRequest(id);
        dispatch("handleResponse", res);
        
      } catch (err) {
      } finally {
        commit("setLoading", false);
      }
    },
    handleResponse({ commit, dispatch }, res) {
      console.log("res" , res)
      if (res.status > 399 && res.status <= 500) {
        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "حدث خطأ أثناء تنفيذ العملية",
            icon: "AlertCircleIcon",

            variant: "danger",
          },
        });
      } else {
        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "تمت العملية بنجاح",
            icon: "CheckSquareIcon",
            variant: "success",
          },
        });
      }
    },
  },
};
